module.exports = __webpack_public_path__ + "img/menu-head.694d22e0.jpg";